<template>
  <b-container fluid>
    <loader watch="powerQualityData" :is-loading="fetchingButtons">
      <b-row align-v="start" align-h="between">
        <b-col md="auto">
          <h2 class="visnet-events__header">Power Quality Panel</h2>
        </b-col>
        <b-col md="auto" class="d-flex justify-content-end align-items-center mw-100">
          <TimeButtons :active-time-button="activeTimeButton" @change="setTimeButton" />
          <DatepickerComponent
            v-if="!activeTimeButton"
            v-model="date"
            :start-date="visnetHub.createdAt"
            @dateChange="setDate"
          />
        </b-col>
      </b-row>
      <template v-if="dataExist">
        <b-row>
          <PowerQualityFiltrationButtons
            :name="$options.name"
            :date="date"
            :active-time-view="activeTimeButton"
            :buttons-names="phasesFeedersButtons"
          />
          <AttributesFiltration :selected-chart="$options.name" />
        </b-row>
        <PowerQualityChart
          v-if="!!dataSeries"
          :active-time-view="activeTimeButton"
          :date="date"
          :chart-data="dataSeries"
        />
      </template>
      <template v-else>
        No data present for the time span
      </template>
    </loader>
  </b-container>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import MomentTimezone from 'moment-timezone';
import jsona from '@/lib/jsona';
import { BUTTONS_NAMES } from '@/components/shared/visnet-hubs-common-consts';
import { FORMAT_YMD } from '@/components/shared/date-format';
import VisnetHubPowerQualityData from '@/resources/visnet-hub-power-quality-data';
import PhasesFeederMethods from '@/components/mixins/phases-feeders-methods';
import DateMethods from '@/components/mixins/date-methods';
import TimeButtons from '../../time-buttons';
import DatepickerComponent from '@/components/shared/datepicker-single-day-component';
import PowerQualityFiltrationButtons from '@/components/substations/visnet-hubs/main-view/phases-feeders/phases-feeders-buttons';
import AttributesFiltration from '@/components/substations/visnet-hubs/main-view/phases-feeders/phases-feeders-attributes-filtration';
import PowerQualityChart from '@/components/substations/visnet-hubs/main-view/phases-feeders/power-quality/power-quality-chart';

export default {
  name: 'PowerQualityChartFiltration',
  components: {
    PowerQualityFiltrationButtons,
    PowerQualityChart,
    AttributesFiltration,
    TimeButtons,
    DatepickerComponent
  },
  mixins: [DateMethods, PhasesFeederMethods],
  data() {
    return {
      powerQualityData: {},
      activeTimeButton: BUTTONS_NAMES[0].value,
      date: this.today(),
      fetchingButtons: false,
      dataExist: null
    };
  },
  computed: {
    ...mapState({
      visnetHub: state => state.substationVisnetHub.visnetHub
    }),
    ...mapGetters({
      dataSeries: 'powerQualityData/filteredPowerQualityData'
    }),
    phasesFeedersButtons() {
      return this.createPhasesFeedersButtons(this.powerQualityData.phases);
    }
  },
  mounted() {
    this.fetchPowerQualityDataInfo();
  },
  beforeDestroy() {
    this.resetPowerQualitySeries();
  },
  methods: {
    ...mapMutations({
      resetPowerQualitySeries: 'powerQualityData/resetPowerQualitySeries'
    }),
    setTimeButton(buttonValue) {
      this.activeTimeButton = buttonValue;

      if (buttonValue) {
        this.setDate(this.today());
      } else {
        this.fetchPowerQualityDataInfo();
      }
    },
    setDate(newDate) {
      this.date = newDate;

      this.fetchPowerQualityDataInfo();
    },
    async fetchPowerQualityDataInfo() {
      this.fetchingButtons = true;
      this.resetPowerQualitySeries();

      const { externalVisnetHubId, projectCode, substationCode } = this.$route.params;
      const { startDate, endDate } = this.selectTimespan(this.activeTimeButton, this.date);

      try {
        const response = await VisnetHubPowerQualityData({ externalVisnetHubId }).get({
          project_code: projectCode,
          substation_code: substationCode,
          start_date: startDate,
          end_date: endDate,
          basic_info_only: true,
          include: 'phases,phases.feeders'
        });

        if (!response) return Error;
        if (response.status === 404) return;

        this.powerQualityData = jsona.deserialize(response.body);

        this.dataExist = true;
      } catch (error) {
        this.dataExist = false;
      }
      this.fetchingButtons = false;
    },
    today() {
      return MomentTimezone(new Date()).format(FORMAT_YMD);
    }
  }
};
</script>
